import { create } from 'zustand';
import type { DateSelection } from 'containers/Dashboard/types/dashboard.types';

interface DashboardStoreState {
  selectedDate: DateSelection;
  selectedDeviceGroups: number[];
  /** Incremented by the header refresh button and auto-refresh. */
  refreshTick: number;
  setSelectedDate: (selectedDate: DateSelection) => void;
  setSelectedDeviceGroups: (selectedDeviceGroups: number[]) => void;
  bumpRefreshTick: () => void;
  clearDashboards: () => void;
}

class EmptyDateSelection implements DateSelection {
  declare type: DateSelection['type'];
  declare resolution: DateSelection['resolution'];
  declare subDateModified: DateSelection['subDateModified'];
}

const INITIAL: Pick<
  DashboardStoreState,
  'selectedDate' | 'selectedDeviceGroups' | 'refreshTick'
> = {
  selectedDate: { ...new EmptyDateSelection() },
  selectedDeviceGroups: [],
  refreshTick: 0,
};

export const useDashboardStore = create<DashboardStoreState>((set) => ({
  ...INITIAL,
  setSelectedDate: (selectedDate) => set({ selectedDate }),
  setSelectedDeviceGroups: (selectedDeviceGroups) =>
    set({ selectedDeviceGroups }),
  bumpRefreshTick: () => set((s) => ({ refreshTick: s.refreshTick + 1 })),
  clearDashboards: () => set({ ...INITIAL }),
}));

export const clearDashboardSelection = () =>
  useDashboardStore.getState().clearDashboards();
